/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_hplc_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flow scales with diameter² and inversely with particle size.`)
};

const es_hplc_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El caudal escala con el diámetro² y de forma inversa con el tamaño de partícula.`)
};

const de_hplc_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Fluss skaliert mit dem Durchmesser² und umgekehrt mit der Partikelgröße.`)
};

const nl_hplc_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flow schaalt met diameter² en omgekeerd met de deeltjesgrootte.`)
};

const fr_hplc_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le débit s'adapte au carré du diamètre et inversement à la taille des particules.`)
};

const it_hplc_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il flusso scala con il diametro² e in modo inverso con la dimensione delle particelle.`)
};

const pt_br2_hplc_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O fluxo escala com o diâmetro² e inversamente com o tamanho de partícula.`)
};

const pt_hplc_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O caudal escala com o diâmetro² e inversamente com o tamanho da partícula.`)
};

const ja_hplc_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`流速は内径の2乗に比例し、粒子径に反比例します。`)
};

const zh_hplc_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`流速随内径的平方放大，并与粒径成反比。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const hplc_ex2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.hplc_ex2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("hplc_ex2", locale)
	if (locale === "en") return en_hplc_ex2(inputs)
	if (locale === "es") return es_hplc_ex2(inputs)
	if (locale === "de") return de_hplc_ex2(inputs)
	if (locale === "nl") return nl_hplc_ex2(inputs)
	if (locale === "fr") return fr_hplc_ex2(inputs)
	if (locale === "it") return it_hplc_ex2(inputs)
	if (locale === "pt-BR") return pt_br2_hplc_ex2(inputs)
	if (locale === "pt") return pt_hplc_ex2(inputs)
	if (locale === "ja") return ja_hplc_ex2(inputs)
	return zh_hplc_ex2(inputs)
};